import type {ReactElement} from 'react';
import React from 'react';
import {noop} from '@Utils/general.util';
import {getTemplateStylesAndProperties} from '@PosterWhiteboard/items/transcript-item/subtitle/template-styles';
import {BaseContextualMenuGridPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-contextual-menu-grid-panel/base-contextual-menu-grid-panel';
import type {ContextualMenuGridPanelItem} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-contextual-menu-grid-panel/base-contextual-menu-grid-panel.types';
import type {TranscriptTemplatesPanelContentProps} from './transcript-templates-panel-content.types';
import {getAssetUrl} from '@Utils/s3.util';
import {SUBTITLE_TEMPLATE_STYLE_THUMBS_URL} from '@PosterWhiteboard/items/transcript-item/subtitle/subtitle.types';
import {getCompatibleVideoFileExtension} from '@Utils/video.util';
import {Thumbnail} from '@Components/thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import styles from './transcript-templates-panel-content.module.scss';

export function TranscriptTemplatesPanelContent({
  isLoading = false,
  onTemplateSelected = noop,
  hideAnimationOptionsAndPresets = false,
  ...props
}: TranscriptTemplatesPanelContentProps): ReactElement<any> {
  const getTemplateItemsForGridPanel = (): ContextualMenuGridPanelItem[] => {
    const templateItems: ContextualMenuGridPanelItem[] = [];

    const sortedTemplates = Object.values(getTemplateStylesAndProperties(hideAnimationOptionsAndPresets)).sort(
      (a, b) => a.templateProperties.sortOrder - b.templateProperties.sortOrder
    );

    const getThumbElementForTemplateItem = (templateId: string): ReactElement<any> => {
      return (
        <Thumbnail
          className={`radius-12 ${styles.thumb}`}
          data={{
            type: ThumbnailType.IMAGE,
            disabled: isLoading,
            imageSrc: getAssetUrl(`${SUBTITLE_TEMPLATE_STYLE_THUMBS_URL}${templateId}.${getCompatibleVideoFileExtension('gif')}?ts=${new Date().getTime()}`),
            showSkeletonLoading: true,
          }}
        />
      );
    };

    sortedTemplates.forEach((template) => {
      if (!template.templateProperties.isHidden) {
        templateItems.push({
          id: template.templateProperties.id,
          thumb: getThumbElementForTemplateItem(template.templateProperties.id),
        });
      }
    });

    return templateItems;
  };

  return (
    <div className={'flex-center'}>
      <BaseContextualMenuGridPanel
        hasCustomDimensions
        selectedId={props.selectedTemplateId}
        isLoading={isLoading}
        items={getTemplateItemsForGridPanel()}
        onSelected={onTemplateSelected}
      />
    </div>
  );
}
